export const GET_SPECIAL_BIRTHDAY_GIFT = "GET_SPECIAL_BIRTHDAY_GIFT";
export const POST_SPECIAL_BIRTHDAY_GIFT = "POST_SPECIAL_BIRTHDAY_GIFT";
export const GET_SPECIAL_BIRTHDAY_GIFT_MEMBERS = "GET_MEMBERS";
export const SHOW_SPECIAL_BIRTHDAY_GIFT = "SHOW_SPECIAL_BIRTHDAY_GIFT";
export const UPDATE_SPECIAL_BIRTHDAY_GIFT = "UPDATE_SPECIAL_BIRTHDAY_GIFT";
export const DELETE_SPECIAL_BIRTHDAY_GIFT = "DELETE_SPECIAL_BIRTHDAY_GIFT";